import { firebaseHelper } from './firebase';

export const generateID = () =>  { return Array.from(Array(10), () => Math.floor(Math.random() * 36).toString(36)).join(''); }
export const hashCode = (s:string) => {return s.split("").reduce(function(a,b){a=((a<<5)-a)+b.charCodeAt(0);return a&a},0); }

const cloudFlareEndpoint='https://api.mattoboard.uk?'
export const cloudFlareImageResize =  (imageURL:string,format='auto',maxWidth?:number,maxHeight?:number) =>{ 
    if (imageURL?.startsWith('http://localhost')) return imageURL
    let i = 'image=' + encodeURI(imageURL);
    i += '&format=' + format
    if (maxWidth) i += '&width=' + maxWidth
    if (maxHeight) i += '&height=' + maxHeight
    return cloudFlareEndpoint + i
}
export function rgb_to_hex(rgb: { r: number; g: number; b: number; }){
    return "#"
            + ("0" + rgb.r.toString(16)).substr(-2)
            + ("0" + rgb.g.toString(16)).substr(-2)
            + ("0" + rgb.b.toString(16)).substr(-2)
}
//Using Geoapify to determine user location.
export async function getUserLocationFromIP(){
    return new Promise((resolve, reject) => {
        const requestOptions = { method: 'GET',};
        let country = null;
        fetch("https://api.geoapify.com/v1/ipinfo?&apiKey=94fc430c15c343cc93b732537277a0cc", requestOptions)
            .then(response => response.json())
            .then(result => { console.log(result); country = result?.country?.names?.en; resolve(country)})
            .catch(error => console.log('error', error));
    })
}

export const titleCase = str => str == null ? null : `${str[0]?.toUpperCase()}${str.slice(1).toLowerCase()}`

export const cloudflareCDN = (url: string | null | undefined, format: string): string => {
    if (!url) return '';
    if (url?.startsWith('https://api.mattoboard.uk/?image='))  {
        try { const x = new URL(url).searchParams.get('image'); if (x != null) url = x; }
        catch { /* empty */ }
    }
    if (url?.startsWith('http://localhost')) return url
    if (url?.startsWith('data:')) return url
    if (url?.startsWith('meshes') || url?.startsWith('gltfs')) return firebaseHelper.URLFromRef(url)
    // Avoid double-encoding already-escaped URLs (e.g. %20 -> %2520)
    let normalizedUrl = url;
    try {
        normalizedUrl = decodeURIComponent(url!);
    } catch {
        normalizedUrl = url;
    }
    const s = format.split(',')
    let i = 'image=' + encodeURI(normalizedUrl!);
    s.forEach(x => { i += '&' + x?.trim() })
    const u = 'https://api.mattoboard.uk?' + i
    return u
}

export const unflattenObject = (data) => {
    if (Object(data) !== data || Array.isArray(data))
        return data;
    const regex = /\.?([^.\[\]]+)|\[(\d+)\]/g,
        resultholder = {};
    for (const p in data) {
        let cur = resultholder,
            prop = "",
            m;
        while (m = regex.exec(p)) {
            cur = cur[prop] || (cur[prop] = (m[2] ? [] : {}));
            prop = m[2] || m[1];
        }
        cur[prop] = data[p];
    }
    return resultholder[""] || resultholder;
};

export function imagetoBlob(dataURI) {
    var byteString = atob(dataURI.split(',')[1]);
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    var blob = new Blob([ab], {type: mimeString});
    return blob;
}

/**
 * Determines if the current environment is staging or production
 * @returns {boolean} true if staging, false if production
 */
export const isStaging = (): boolean => {
    const hostname = typeof window !== 'undefined' ? window.location.hostname : undefined;

    if (!hostname) {
        // Default to staging, as we're likely running locally or in a test environment
        return true;
    }

    // Production: beta.mattoboard.com, mattoboard.com, firms.mattoboard.com
    if (
        hostname === 'beta.mattoboard.com' ||
        hostname === 'mattoboard.com' ||
        hostname === 'firms.mattoboard.com'
    ) {
        return false;
    }

    // Staging: localhost, *.web.app (preview), daily.mattoboard.com, etc.
    return true;
};


/**
 * Currencies that don't use decimal points (e.g., Japanese Yen)
 */
export const zeroDecimalCurrencies = [
    'bif', 'clp', 'djf', 'gnf', 'jpy', 'kmf', 'krw',
    'mga', 'pyg', 'rwf', 'vnd', 'vuv', 'xaf', 'xof', 'xpf',
];

/**
 * Formats a price amount for display with proper currency formatting
 * @param amount - The amount in smallest currency unit (e.g., cents for USD)
 * @param currency - The currency code (e.g., 'usd', 'eur')
 * @param showDecimals - Whether to show decimal places
 * @param style - The formatting style ('currency' or 'decimal')
 * @returns Formatted price string
 */
export function formatPrice(
    amount: number,
    currency: string = 'usd',
    showDecimals: boolean = true,
    style: 'currency' | 'decimal' = 'currency',
): string {
    if (!currency) return '';
    const args: any = { style: style, currency: currency };
    if (showDecimals === false) {
        args.minimumFractionDigits = 0;
        args.maximumFractionDigits = 0;
    }
    const formatCurrency = new Intl.NumberFormat('en-US', args);
    if (zeroDecimalCurrencies.includes(currency.toLowerCase())) {
        return formatCurrency.format(amount);
    } else {
        return formatCurrency.format(amount / 100);
    }
}
